import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView w="100%" textCenter m="0 auto">
          <Parallax bgImage={mobileAbout} bgImageAlt="Entree Dish" strength={1}>
            <div style={{ height: '300px' }} />
          </Parallax>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          m="0 auto"
          w="96%"
          h="600px"
          maxWidth="1400px"
          image={`url(${about}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
